// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  enableBugsnag : false, 
  production: false,
  apiUrl: 'https://dev-yokahu-frontend.yokahu.co/api',
  Stripe_Publishable_Key:
   'pk_test_51HUXLnJiyZvNDOChgKwYNPcdXeSLChlNZgqoMiDsT9RXR6QKxOYqb76AKDttgGjayPJnOg2M6pQg2r7GU6E76Yk100ObCfl1wO',
 sessionUserTimeOut : 30,
  zoomForCountry : {
    'Jamaica': 8,
    'The Bahamas': 8,
    'US Virgin Islands': 8,
    'Saint Lucia': 11
  },
  productListForCountry : {
    'Austria': 'year',
    'India': 'month',
    'Algeria': 'month',
    'Saint Lucia': 'month',
    'United Kingdom': 'month'
  },
  gmap_key:'AIzaSyDftDM4EXczuSZlq7mc5vwl_VYhLWgazwc' ,
  baseUrl : 'https://dev-yokahu-frontend.yokahu.co',
  brokerApiUrl :'https://dev.cat-risk.com',
  captcha_siteKey: '6LfZW_srAAAAACWG6dJsgos-954mPZokNfJu_aX9',
  testingMode: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
